<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:header>
        <!-- <div> -->
        <v-toolbar dark color="blue darken-3">
          <!-- <v-row align="center" justify="space-around"> -->
          <v-text-field
            v-model="search"
            clearable
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search..."
            dense
          ></v-text-field>
        </v-toolbar>
        <!-- </div> -->
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-radio-group v-model="radioGroup" dense>
            <v-col v-for="(item, i) in props.items" :key="i" cols="12">
              <v-card :color="item.Color" dark dense elevation="6">
                <v-card-title class="font-weight-bold">
                  <v-radio
                    :key="i"
                    :value="item.MID"
                    @click="radioClicked(item.MID)"
                  ></v-radio>
                  <v-avatar size="20px" class="ma-1"
                    ><img :src="item.FlagUrl"
                  /></v-avatar>
                  <div v-if="item.Extras.length < 1">
                    {{ item.Name }} / {{ item.Event }}
                  </div>
                  <div v-else>
                    {{ item.Name }}
                  </div>
                  <v-chip dark class="font-weight-bold ma-1" outlined
                    >{{ item.Status }} / {{ item.Tid }}
                  </v-chip>
                </v-card-title>
                <v-card-subtitle
                  v-if="item.Extras.length > 0"
                  v-text="item.Extras"
                >
                </v-card-subtitle>
                <v-card-subtitle
                  v-if="item.Message.length > 0"
                  style="color: white"
                >
                  {{ item.Active + " Msg: " + item.Message }}
                </v-card-subtitle>
                <v-progress-linear
                  color="white"
                  buffer-value="0"
                  stream
                  v-if="item.Message.length > 0"
                ></v-progress-linear>

                <!-- <v-card-subtitle v-else></v-card-subtitle> -->
                <v-card-actions class="justify-center">
                  <v-chip
                    v-if="item.Enabled"
                    color="primary"
                    dark
                    min-width="200"
                    rounded
                    small
                    :disabled="!item.Enabled"
                    :to="{ name: 'PilotStatus', params: { id: item.RegId } }"
                    >Change Status
                    <v-icon right small>mdi-edit-outline</v-icon></v-chip
                  >
                  <v-chip
                    v-if="item.Enabled && item.Message.length > 0"
                    color="primary"
                    rounded
                    small
                    :disabled="!item.Enabled"
                    :to="{ name: 'AddMsg', params: { id: item.RegId } }"
                    >Edit Msg.
                    <v-icon small right>mdi-comment-processing-outline</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="item.Enabled && item.Message.length == 0"
                    color="primary"
                    rounded
                    small
                    :disabled="!item.Enabled"
                    :to="{ name: 'AddMsg', params: { id: item.RegId } }"
                    >Add Msg.
                    <v-icon small right>mdi-comment-processing-outline</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="item.Enabled && item.HasPosition"
                    color="primary"
                    rounded
                    small
                    :disabled="!item.Enabled"
                    :to="{
                      name: 'AddPilotPosition',
                      params: { id: item.RegId, eventid: item.EventId },
                    }"
                    >Edit Pos.<v-icon right small>mdi-map-marker-right</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="item.Enabled && !item.HasPosition"
                    color="primary"
                    rounded
                    small
                    :disabled="!item.Enabled"
                    :to="{
                      name: 'AddPilotPosition',
                      params: { id: item.RegId, eventid: item.EventId },
                    }"
                    >Add Pos.<v-icon right small>mdi-map-marker-plus</v-icon>
                  </v-chip>
                  <v-chip
                    :href="item.GoogleMapLink"
                    target="_blank"
                    v-if="item.HasPosition"
                    color="primary"
                    rounded
                    small
                    >Google<v-icon small right>mdi-map</v-icon></v-chip
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-radio-group>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-card outlined href>
          <v-container fluid>
            <a :href="selectedTelMID"> {{ selectedTelMID }} </a>
            <div>.</div>
            <a :href="selectedSmsMID"> {{ selectedSmsMID }} </a>
          </v-container>
        </v-card>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  name: "AirboxCard",
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      itemsPerPageArray: [10, 20, 40, 100],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 10,
      sortBy: "name",
      keys: ["RID", "Name", "Status", "Event", "Tid", "MID"],
      selectedRegIds: [],
      selectedRegIdsToCopy: "",
      radioGroup: 1,
      selectedTelMID: "",
      selectedSmsMID: "",
      regid: Number,
      loggedIn: false,
    };
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  created() {
    //
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    checkBoxClicked() {
      this.selectedRegIdsToCopy = this.radioGroup.value; //this.selectedRegIds.toString();
    },
    radioClicked(mid) {
      // console.log('MID:',mid)
      this.selectedTelMID = "tel:" + mid;
      this.selectedSmsMID = "sms:" + mid;
    },
  },
};
</script>